
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UserRound, MapPin } from 'lucide-react';
import { TrainingFormValues } from '../../../types';

interface TrainingDetailsSectionProps {
  form: UseFormReturn<TrainingFormValues>;
}

export const TrainingDetailsSection: React.FC<TrainingDetailsSectionProps> = ({ form }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Training Details</h3>
      
      <FormField 
        control={form.control} 
        name="professor" 
        render={({ field }) => (
          <FormItem>
            <FormLabel>Professor / Coach <span className="text-muted-foreground font-normal">(optional)</span></FormLabel>
            <FormControl>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <UserRound className="h-4 w-4 text-muted-foreground" />
                </div>
                <Input placeholder="Enter professor name" className="pl-10" {...field} />
              </div>
            </FormControl>
            <FormDescription>
              Record who led the training session
            </FormDescription>
            <FormMessage />
          </FormItem>
        )} 
      />
      
      <FormField 
        control={form.control} 
        name="location" 
        render={({ field }) => (
          <FormItem>
            <FormLabel>Location <span className="text-muted-foreground font-normal">(optional)</span></FormLabel>
            <FormControl>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <MapPin className="h-4 w-4 text-muted-foreground" />
                </div>
                <Input placeholder="Enter training location" className="pl-10" {...field} />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )} 
      />
    </div>
  );
};
